module.exports = __webpack_public_path__ + "static/genart.818bcc3e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/genart.svg
// module id = 1711
// module chunks = 114276838955818 263791100135453